import "../../../utils/messages";
import { BILLING_MESSAGES } from "../../../utils/messages";
import { ClientMessage } from "../../../utils/objects";
import qs from 'querystring';

export function assignBillingRequests(api) {
    /****************************************BILLING (CARNET / RECORDS / REPORT / EXPORT)*********************************************************/
    let billingBaseURL = "/enterprise/billing/invoices";

    // Distingue gli errori 422 dell'API invoice (no_tickets_found / customer_not_found) dal default.
    function handle422InvoiceError(e, defaultMessage) {
        if (e && e.response && e.response.status == 422) {
            var code = e.response.data && e.response.data.error;
            if (code == "no_tickets_found") return api.checkError(e, BILLING_MESSAGES.NO_TICKETS_FOUND);
            if (code == "customer_not_found") return api.checkError(e, BILLING_MESSAGES.CUSTOMER_NOT_FOUND);
        }
        return api.checkError(e, defaultMessage);
    }

    api.getCarnets = async function (idCustomer) {
        var queryString = idCustomer != null ? '?id_customer=' + idCustomer : '';

        var response = await api.get('/billing/carnet' + queryString, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BILLING_MESSAGES.CARNET_LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.createCarnet = async function (carnet) {
        var clientMessage = ClientMessage.success(BILLING_MESSAGES.CARNET_CREATED);

        var response = await api.post(
            '/enterprise/billing/carnet',
            JSON.stringify(carnet),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, BILLING_MESSAGES.CARNET_NOT_CREATED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "billingmethods");

        return response;
    }

    api.getInvoices = async function (filters) {
        var queryString = filters != null ? '?' + qs.stringify(filters) : '';

        var response = await api.get(billingBaseURL + queryString, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BILLING_MESSAGES.INVOICE_LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }



    /****************************************INVOICES*********************************************************/

    api.getInvoice = async function (idInvoice) {
        var response = await api.get(billingBaseURL + '/' + idInvoice, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BILLING_MESSAGES.INVOICE_NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.createInvoice = async function (invoice) {
        var clientMessage = ClientMessage.success(BILLING_MESSAGES.INVOICE_CREATED);

        var response = await api.post(
            billingBaseURL,
            JSON.stringify(invoice),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = handle422InvoiceError(e, BILLING_MESSAGES.INVOICE_NOT_CREATED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "billingmethods");

        return response;
    }

    api.deleteInvoice = async function (idInvoice) {
        var clientMessage = ClientMessage.success(BILLING_MESSAGES.INVOICE_DELETED);

        var response = await api.delete(billingBaseURL + '/' + idInvoice, this.buildConfig())
            .then(res => res.status != 400)
            .catch(e => {
                clientMessage = this.checkError(e, BILLING_MESSAGES.INVOICE_NOT_DELETED);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "billingmethods");

        return response;
    }

    api.markInvoice = async function (idInvoice) {
        var clientMessage = ClientMessage.success(BILLING_MESSAGES.INVOICE_MARKED);
        var body = { invoiced: true };

        var response = await api.put(
            billingBaseURL + '/' + idInvoice + '/mark',
            JSON.stringify(body),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, BILLING_MESSAGES.INVOICE_NOT_MARKED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "billingmethods");

        return response;
    }

    // Modalità A: { id_customer, ticket_ids: [...], external_invoice_id?, note? }
    // Modalità B: { id_customer, date_from, date_to, external_invoice_id?, note? }
    // Errori 422 dedicati: no_tickets_found, customer_not_found.
    api.generateInvoice = async function (payload) {
        var clientMessage = ClientMessage.success(BILLING_MESSAGES.INVOICE_GENERATED);

        var response = await api.post(
            billingBaseURL + '/generate',
            JSON.stringify(payload),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = handle422InvoiceError(e, BILLING_MESSAGES.INVOICE_NOT_GENERATED);
            return null;
        });
        if (response)
            this.emitFunction("sendClientMessage", clientMessage, "billingmethods");

        return response;
    }
}
